import { PagingDto } from '../common/paging.dto'
import { RoleNames } from './user.dto'

export class FindUserDto extends PagingDto {
  public searchText: string
  public roleName: RoleNames
  public status?: string
}
